import React from "react";
import { Link } from "react-router-dom";

// CSS
import "./footer.css";

// Components
import CompanyLogo from "../CompanyLogo/CompanyLogo";
import { useShowMango } from "../../hooks/useShowMango";

// Icons
import { AiOutlineFacebook, AiOutlineWhatsApp } from "react-icons/ai";

const Footer = () => {
  const showMango = useShowMango();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <CompanyLogo />
          <p className="footer-company-description">
            Delicious food, delivered fast! Call us now to place your order.
          </p>
          <div className="footer-company-contact">
            <a href="tel:+8801521494760" className="footer-company-phone">
              📞 +880 1521-494760
            </a>
            <p className="footer-company-location">
              📍 Bashundhara, Dhaka - 1229
            </p>
          </div>
        </div>

        <div className="footer-links-row">
          <div className="footer-info-col">
            <h3 className="footer-site-links-title">Quick Links</h3>
            <ul className="footer-site-links-list">
              <li className="footer-site-link">
                <Link to="/">Home</Link>
              </li>
              <li className="footer-site-link">
                <Link to="/menu">Menu</Link>
              </li>
              {showMango && (
                <li className="footer-site-link">
                  <Link to="/mango">Mango</Link>
                </li>
              )}
              <li className="footer-site-link">
                <Link to="/custom">Custom Platters</Link>
              </li>
              <li className="footer-site-link">
                <Link to="/order">Your Order</Link>
              </li>
            </ul>
          </div>

          <div className="footer-info-col">
            <h3 className="footer-company-social-title">Follow Us</h3>
            <div className="footer-company-social-links">
              <a
                href="https://www.facebook.com/share/1BJG44zurx/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiOutlineFacebook className="footer-company-social-links-icon" />
              </a>
              <a
                href="https://wa.me/+8801521494760"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <AiOutlineWhatsApp className="footer-company-social-links-icon" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <p>© {new Date().getFullYear()} Ekhoni Khabo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
